module.exports = __webpack_public_path__ + "media/images/lb/779-d7436bcc803bb64bd9f1d7b4d9fb1aee.svg";